import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	done: {
		id: 'card.common.tick.done',
		defaultMessage: 'Done',
		description: 'Tooltip around an icon indicating whether an issue is completed',
	},
});
